// css
import "./scss/layout.scss";

// js
import 'bootstrap';
import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/dropdown';
import elasticScroll from 'elastic-scroll-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import {isMobile} from './isMobile';
import {progressJS} from './progressJS'
import Navbar from './navbar';
import Sticky from 'sticky-js';

// ___________________________________________________________________________

/**
 * Array.prototype.forEach() polyfill
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Array.prototype.forEach) {
	Array.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

// ___________________________________________________________________________

// Magazine
import Magazine from './magazine';
Magazine.init();

// ___________________________________________________________________________

const DEBUG = false;

if(DEBUG) {
    $('body').addClass('debug');
}

// ___________________________________________________________________________

//this attachs the scroll value to .elementClassToAttach
document.addEventListener("DOMContentLoaded", function (event) {
    progressJS.start({});
});

// ___________________________________________________________________________

var is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
var is_Edge = navigator.userAgent.indexOf("Edge") > -1;
var is_chrome = !!window.chrome && !is_opera && !is_Edge;
var is_explorer= typeof document !== 'undefined' && !!document.documentMode && !is_Edge;
var is_firefox = typeof window.InstallTrigger !== 'undefined';
var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// ___________________________________________________________________________

// kickoff smoothscroll
smoothscroll.polyfill();

// ___________________________________________________________________________

/**
 * js foreach
 * @param {type} array
 * @param {type} callback
 * @param {type} scope
 * @returns {undefined}
 */
var forEach = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};

// ___________________________________________________________________________

if(DEBUG) {
    console.log('In debug mode.');
    // DEBUG: responsive
    $('.navbar-brand').addClass('debug');

}

// ___________________________________________________________________________

function isM() {
    let t = isMobile.test();
}

// ___________________________________________________________________________


// altezza vh e vw
$(document).ready(function() {
    if(!isM()) {

        // Se c'è un solo blocks ed è full-height, footerHeight = altezza del footer
        let footerHeight = 0;
        if($('.blocks').length == 1 && $('.blocks .section.full-height').length == 1) {
            footerHeight = $('footer.footer').height();
        }

        // set vh
        let vh = (window.innerHeight - footerHeight) * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        window.addEventListener('resize', () => {
            let vh = (window.innerHeight - footerHeight) * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        // Fix live vw value
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // set vw
        let vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vw', `${vw}px`);

        window.addEventListener('resize', () => {
            let vw = window.innerWidth * 0.01;
            document.documentElement.style.setProperty('--vw', `${vw}px`);
        });
    } // ! mobile

});

// ___________________________________________________________________________

function removeFirstChar(str){
    if(str.charAt(0) === "#"){
      str = str.substring(1);
    }
    return str;
  }

// Modal
$(document).ready(function() {

    $("a[href*='#']").click(function(e) {
        let hash = $(this).attr('href').split('#')[1];
        $('#modal-' + hash).modal('show');
    });  

    // click modal trigger
    $('.modaltrigger').each(function() {
        let href_main = $(this).attr('href');
        let href_container = $(this).find('a').attr('href');
        let href = href_main || href_container;
        
        // open
        $(this).click(function(e) {
            e.preventDefault();
            let rel = removeFirstChar(href);
            $('#modal-' + rel).modal('show');
        })
    })

    // run window hash
    if(window.location.hash) {
        // Fragment exists
        let rel = removeFirstChar(window.location.hash);
        if($('#modal-' + rel)) {
            $('#modal-' + rel).modal('show');
        }
    }
})

// ___________________________________________________________________________

var sticky = new Sticky('#header', {
    stickyClass: 'sticky'
});

// ___________________________________________________________________________

$(document).ready(function() {

    // MAGAZINE LINK TO PARENT
    var $parent_link_s = document.querySelectorAll('.get-link-from-child');
    if($parent_link_s && $parent_link_s.length > 0) {
        $parent_link_s.forEach(($anchestor) => {
            var $child = $anchestor.querySelector('.give-link-to-anchestor');

            if($child && $child != null) {
                var href = $child.getAttribute('href');
                $anchestor.addEventListener('click',() => {
                    window.location = href;
                });
            }
        });
    }

});

// ___________________________________________________________________________












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// -------------------------------------------------------------------------

// HELLO! HOW ARE YOU?
if(!DEBUG) {
    if(is_safari) {
        console.log(` .----------------\n mMMMMMMMMMMMMM:\n mMMMMMMMMMMMMM/\n dMMMy++++++++++++\n mMMM/              \n mMMMmyyyyyyyyy     \n mMMMMMMMMMM    \n dMMMNhdddddddh    \n dMMM/             \n mMMMs::::::::::/:\n mMMMMMMMMMMMMM/\n mMMMMMMMMMMMMM/\n .:-:-----------::\n\n made by encom.io`);
    } else {
        console.log('%c               ', 'display:block;line-height:100px;font-size:150px;background-repeat:no-repeat;background:url(data:image/png;base64,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) 100% 50% no-repeat;');
    }
}
// -------------------------------------------------------------------------